import { Modalator } from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class PasswordBtn extends HTMLAnchorElement {
    connectedCallback() {
        this.addEventListener('click', (e) => {
            e.preventDefault();

            const url = this.dataset.href;
            const modal = new Modalator();

            modal.initRemoteModal('#modal-edit-my-password', url, null, (data) => {
                toastr.success('Enregistrement effectué');
            }, () => {
                // Met à jour la présentation des alertes
                setTimeout(() => {
                    const alertBlock = document.querySelector('.alert-block');
                    if (alertBlock) {
                        alertBlock.classList.add('m-5');
                    }
                    const alertBlockCloseBtn = document.querySelector('.alert-block>button');
                    if (alertBlockCloseBtn) {
                        alertBlockCloseBtn.classList.add('btn-close');
                        alertBlockCloseBtn.innerHTML = '';
                        alertBlockCloseBtn.addEventListener('click', () => {
                            alertBlock.remove();
                        });
                    }
                }, 100);
            });
        });
    }
}
